<div class="property-maintenance">
    <tg-info-box
        compact
        tgStyle="warning">
        <tg-info-box-heading>
            Property listing is undergoing scheduled maintenance
        </tg-info-box-heading>
        Try listing again later today. We apologise for any inconvenience.
        <div class="property-maintenance__info-box-action">
            <tg-info-box-actions>
                <a href="https://www.trademe.co.nz/a/property">Back to Trade Me Property</a>
            </tg-info-box-actions>
        </div>
    </tg-info-box>
</div>
